<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/contacts/overview']">Zurück zur Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Firma bearbeiten  <cds-icon shape="two-way-arrows"></cds-icon>  {{ company?.cid }}</h2>
  <app-contact-form
    *ngIf="company"
    (submitContact)="updateCompany($event)"
    [newCompany]="company"
    [editing]="true">
  </app-contact-form>
</main>
